import Paper from '@gogame/ui/Paper';

export const withPaper =
  (BaseComponent) =>
  ({ withPaper = true, index = 0, ...props }) => {
    return (
      <div
        data-cy={`chart`}
        data-cy-index={index}
        style={{
          width: '100%',
        }}
      >
        {withPaper ? (
          <Paper variant={'outlined'}>
            <BaseComponent {...props} />
          </Paper>
        ) : (
          <BaseComponent {...props} />
        )}
      </div>
    );
  };

export default withPaper;
